import { Component, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NavigationHelper } from "../../../services/navigation.helper";
import { Navigation } from "../../../model/navigation";
import { animate, style, transition, trigger } from "@angular/animations";
import { SingleChoice } from "../../../model/singlechoice";
import { NavigationEnd, Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DependentChoice } from "../../../model/dependentchoice";
import { Location } from "@angular/common";
@Component({
  selector: "frame-mobile",
  templateUrl: "./frame-mobile.component.html",
  styleUrls: ["./frame-mobile.component.css"],
  animations: [
    trigger("fadeInRight", [
      transition(":enter", [
        style({ transform: "translateX(-100%)", opacity: 0 }),
        animate(
          "700ms 0ms ease-in",
          style({ transform: "translateX(0)", opacity: 1 })
        ),
      ]),

      transition(":leave", [
        style({ transform: "translateX(0)", opacity: 1 }),
        animate(
          "700ms 0ms ease-out",
          style({ transform: "translateX(-100%)", opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class FrameMobileComponent implements OnInit {
  currentScreen: number = 0;
  currentNavigation: Navigation;
  current_choice: BehaviorSubject<SingleChoice> = new BehaviorSubject(
    SingleChoice.EMPTY
  );
  current_dependent: BehaviorSubject<DependentChoice> = new BehaviorSubject(
    DependentChoice.EMPTY
  );
  current_topic: BehaviorSubject<string> = new BehaviorSubject<string>("");
  dependent_Topic: BehaviorSubject<string> = new BehaviorSubject<string>("");
  showFilterPalette = false;

  constructor(
    private navigation: NavigationHelper,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.currentNavigation = new Navigation("", "", "", null, null);
  }

  ngOnInit(): void {

    this.navigation.refresh();
    this.updateAllFromNavigation();
    this.checkTopicAndId();
    this.checkRouteForMenu();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.navigation.navigatingBack) {
          this.navigation.finishBackNavigation();
          this.updateAllFromNavigation();
          this.checkTopicAndId();
          this.checkRouteForMenu();
          return;
        }

        this.updateAllFromNavigation();
        this.checkTopicAndId();
        this.checkRouteForMenu();
      }
    });

    this.route.params.subscribe((params) => {
      const topic = params["id"] || "";

      if (topic) {
        this.current_topic.next(topic);
      }
    });

    if (!this.navigation.freshNavigation.topic) {
      this.currentNavigation.topic = "tickets";
      this.current_topic.next("tickets");
      this.currentScreen = 1;
    }

    this.navigation.topic.subscribe((topic) => {
      if (!this.navigation.navigatingBack && topic) {
        this.updateAllFromNavigation();
      }
    });
  }

  updateAllFromNavigation(): void {
    const nav = this.navigation.freshNavigation;

    if (nav.action.includes("filter")) {
      this.showFilterPalette = true;
      this.currentScreen = 2;
    } else {
      this.showFilterPalette = false;
    }
    if (nav.action.includes("choose")) {
      this.currentScreen = 4;
      this.current_choice.next(this.navigation.currentChoice);
    }
    if (nav.topic) {
      this.current_topic.next(nav.topic);
    } else if (
      nav.action.includes("edit") ||
      nav.action.includes("fragment") ||
      nav.action.includes("multi-process")
    ) {
      this.currentScreen = 2;
    } else if (nav.action.includes("result")) {
      this.currentScreen = 1;
    } else {
      this.currentScreen = 1;
    }
  }

  private checkTopicAndId(event?: any) {
    const nav = this.navigation.freshNavigation;
    this.currentNavigation = nav;

    if (nav.topic === "") {
      this.currentScreen = 0;
    } else if (nav.topic === "tickets" && (nav.id === "" || nav.id === "-1")) {
      this.currentScreen = 1;
    } else if (nav.id === "") {
      this.currentScreen = event && Number.isInteger(event) ? 2 : 1;
    } else {
      this.currentScreen = 2;
    }
  }
  private checkRouteForMenu(): void {
    const cleanUrl = this.router.url.split(/[?#]/)[0].replace(/\/+$/, "");

    if (cleanUrl === "/menu") {
      this.currentScreen = 3;
    }
  }

  toggleFilterForTicket(): void {
    this.showFilterPalette = true;
    this.currentScreen = 2;
  }

  selectItem(event: any): void {
    if (event.type === "dependent") {
      this.currentScreen = 4;
    }

    this.checkTopicAndId(event);

    if (this.currentNavigation.id && this.currentNavigation.id !== "") {
      this.currentScreen = 2;

      return;
    }
  }

  relaySingleChoice(choice: SingleChoice): void {
    choice.waiting.subscribe(() => {
      this.current_choice.next(SingleChoice.EMPTY);
      this.currentScreen = 2;
    });

    this.current_choice.next(choice);
    this.currentScreen = 4;
  }
  goBack(): void {
    this.navigation.back();
  }

  goToMenu(): void {
    this.currentScreen = 3;
  }
  get topic() {
    return this.currentNavigation.topic;
  }
  get choosing(): boolean {
    const c = this.current_choice.value;
    return c && c !== SingleChoice.EMPTY;
  }

  get chooseTopic(): string {
    return this.choosing ? this.current_choice.value.topic : "";
  }

  get currentChoice(): SingleChoice {
    const sc = this.current_choice.value;
    return sc ? sc : SingleChoice.EMPTY;
  }
  get currentNav(): Navigation {
    const nav = this.navigation.current;
    if (nav) {
      return nav;
    } else {
      return this.currentNavigation;
    }
  }
}
